<template>
  <FormPto
    v-model="modelFormData"
    :is-edit="isEdit"
    :is-sending="isSending"
    @request="onSubmit"
    @cancel="onCancel"
  >
    <VSelect
      label="Стройка"
      name="building"
      :items="buildingList"
      :disabled="isParentEntityPage"
      :search="!isParentEntityPage"
      :handler-search="GETBuildingList"
    />

    <VSelect
      label="Статус"
      name="status"
      :items="statusObjectList"
      :handler-search="GETStatusObjectList"
      search
    />

    <AppInputDate
      title="Дата начала"
      name="start_date"
      type="single"
    />

    <AppInputDate
      title="Дата окончания"
      name="stop_date"
      type="single"
    />

    <VInput
      label="Наименование объекта"
      name="name"
      required
      min-length="3"
    >
      <Validation for="required">Поле обязательно</Validation>
      <Validation for="minLength">Минимальная длина названия 3 символа</Validation>
    </VInput>

    <VSelect
      label="Ответственный сметный"
      name="estimate_responsible"
      :items="userList"
      :handler-search="GETUserList"
      search
      userSelect
    />

    <VSelect
      label="Заказчик"
      name="customer"
      item-text="long_name"
      :items="partnerList"
      :handlerSearch="GETPartnerList"
      search
    />
    
    <VSelect
      label="Договор"
      name="treaty"
      item-text="treaty_number"
      :items="contractsList"
      :handlerSearch="GETContractsList"
      search
    />

    <VCheckbox
      title="Субподрядчик Интекс"
      name="is_intex"
      class="form__checkbox-wrap"
      @valueChange="changeIsIntex"
    />
    
    <VInput
      v-if="visibleGeneralContractor"
      label="Г/П к вычету %"
      name="deduction"
      pattern="^\d*(?:[.]\d{0,3})?$"
    >
      <Validation for="pattern">Формат ввода: "1000.001"</Validation>
    </VInput>
    
    <VSelect
      v-if="visibleGeneralContractor"
      label="Генподрядчик"
      name="general_contractor"
      item-text="long_name"
      :items="partnerList"
      :handlerSearch="GETPartnerList"
      search
    />
    
  </FormPto>
</template>

<script>
import AppInputDate from '@/components/page/input/AppInputDate'
import FormPto from '@/components/pto/form/FormPto'
import Validation from '@/components/page/Form/Validation.vue'
import VCheckbox from '@/components/page/Form/VCheckbox/VCheckbox'
import VInput from '@/components/page/Form/Vinput/Vinput.vue'
import VSelect from '@/components/page/Form/VSelect.vue'

import { MIXIN_FORM_PTO } from '@/mixins/module/pto/mixinFormPto'
import { MIXIN_USER_LIST } from '@/mixins/handbook/userList'
import { mixinPtoObjectSelect } from '@/mixins/module/pto/mixinPtoObjectSelect'
import { prepareObjectFormData } from '@/utils/page/pto/object'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'FormPtoObject',
  components: {
    AppInputDate,
    FormPto,
    Validation,
    VCheckbox,
    VInput,
    VSelect
  },
  mixins: [MIXIN_FORM_PTO, MIXIN_USER_LIST, mixinPtoObjectSelect],
  data: () => ({
    isIntex: false
  }),

  computed: {
    ...mapState('handbook/partner', {
      partnerList: 'partnerList',
      generalContractor: 'generalContractor'
    }),
    visibleGeneralContractor () {
      return this.isIntex
    }
  },
  async mounted () {
    this.isIntex = this.modelFormData?.is_intex
  },
  methods: {
    ...mapActions('handbook/partner', {
      GETGeneralContractor: 'GETGeneralContractor'
    }),
    onSubmit (data) {
      if (!this.isIntex) data.general_contractor = this.generalContractor[0]
      this.$emit('request', prepareObjectFormData(data))
    },
    changeIsIntex (value) {
      this.isIntex = value
    }
  }
}
</script>
